<template>
    <div>
        <div class="row px-3">
            <div class="col-12 align-items-center">
                <h1 class="font-weight-bold">เลือกรายการขนส่ง
                </h1>
            </div>
        </div>
        <div class="scroll-table scroll-bar-pop scrollbar-style table-responsive background-color-table">
            <table class="table">
                <thead>
                    <tr class="text-center">
                        <th colspan="2">รายชื่อขนส่ง</th>
                        <th>ระยะเวลาขนส่ง</th>
                        <th>ราคาจัดส่ง</th>
                        <th>ราคารวม</th>
                        <!-- <th>หมายเหตุ</th> -->
                        <th>การใช้งาน</th>
                    </tr>
                </thead>
                <tbody class="table-tbody">
                    <template v-for="(courier, keyId) in courierList">
                        <tr  v-if="keyId === 0 && isSelected.errorShow === true">
                            <td :colspan="6" class="text-center">
                                    <span class="text-danger">
                                        กรุณาเลือกขนส่ง
                                    </span>
                            </td>
                        </tr>
                        <tr :key="keyId"
                            :class="['text-center', displayLock(courier) ? 'filter-gray' : '']"
                        >
                            <td>
                                <img 
                                    class="img-icon mt-3" 
                                    :src="courier.logo_url" 
                                    img-alt="courierIcon" 
                                    width="150" 
                                />
                            </td>
                            <td>
                                <h4 class="courier-name text-center">
                                    {{courier.name}}
                                </h4>
                                <h5 class="text-muted">{{ deliveryServiceText(courier.delivery_selected) }}</h5>
                            </td>
                            <td>
                                <h4 class="courier-name text-center">
                                    {{ !displayLock(courier) ? `${courier.duration} วัน` : '-' }}
                                </h4>
                            </td>
                            <td>
                                {{courier.sum_price_shop | numFormat('0,0.00')}} บาท
                                <div 
                                    v-if="courier.service_shop > 0" 
                                    class="small text-specialarea"
                                    v-b-tooltip.hover.bottom title="ค่าบริการ (ไม่ได้คิดรวม)"
                                >
                                    ( +{{ courier.service_shop | numFormat('0,0.00') }} )
                                </div>
                            </td>
                            <td>
                                {{ parseFloat(courier.summary_of_service_and_price)  | numFormat('0,0.00') }}
                            </td>
                            <!-- <td>
                                {{ courier.condition.max_height }}
                            </td> -->
                            <td>
                                <b-button 
                                    :variant="(keyId === isSelected.courierIndex) ? 'outline-primary' : 'primary' "
                                    class="px-4"
                                    :disabled="displayLock(courier)"
                                    @click="selectCourier(keyId)"
                                >
                                    <i class="fas fa-check" 
                                        v-if="keyId === isSelected.courierIndex"
                                    >
                                    </i>
                                    เลือกขนส่ง
                                </b-button>
                            </td>
                        </tr>
                        <tr v-if="isSelected.list.id === courier.id && courier.delivery_selected == 'pick_up_drop_off'">
                            <td :colspan="6" class="text-center hide-top-border">
                              <div class="w-100">
                                <b-form-group
                                    label="กรุณาเลือกประเภทการจัดส่ง"
                                    v-slot="{ ariaDescribedby }"
                                >
                                <b-form-radio-group
                                    id="btn-radio-delivery"
                                    v-model="isSelected.delivery_selected"
                                    :options="optionsDelivery"
                                    :aria-describedby="ariaDescribedby"
                                    button-variant="outline-primary"
                                    size="md"
                                    name="radio-btn-outline"
                                    buttons
                                    stacked
                                ></b-form-radio-group>
                                </b-form-group>
                              </div>
                            </td>
                        </tr>
                        <tr v-if="displayLock(courier)">
                            <td :colspan="6" class="text-center hide-top-border text-danger">
                              <div v-if="courier.error_code === 'notSupport.country'">
                                ขนส่งไม่รองรับประเทศปลายทาง
                              </div>
                              <div v-if="courier.error_code === 'notSupport.weight'">
                                    ขนส่งไม่สามารถรองรับน้ำหนัก หรือ ขนาดกล่องตามขนาดที่กรอกได้<br>
                                <div v-if="courier.condition.max_width">
                                    ความกว้างของขนาดกล่องต้องไม่เกิน {{ courier.condition.max_width }} ซม
                                </div>
                                <div v-if="courier.condition.max_length">
                                    ความยาวของขนาดกล่องต้องไม่เกิน {{ courier.condition.max_length }} ซม
                                </div>
                                <div v-if="courier.condition.max_height">
                                    ความสูงของขนาดกล่องต้องไม่เกิน {{ courier.condition.max_height }} ซม                                
                                </div>
                                <div v-if="courier.condition.min_shipments">
                                    ส่งพัสดุอย่างต่ำ {{ courier.condition.min_shipments }} ชิ้น
                                </div>
                                <div v-if="courier.condition.max_sum_wlh">
                                     ขนาดรวมต้องไม่เกิน {{ courier.condition.max_sum_wlh }} ซม
                                </div>
                                <div v-if="courier.condition.max_weight">
                                    ขนาดน้ำหนักรวมจะต้องไม่เกิน {{ courier.condition.max_weight }} กรัม
                                </div>
                              </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import { errorCheckPrice } from '@/plugins/index'

export default {
    props: {
        noteToShop: {
            type: String,
            default: ""
        },
        courierList: {
            type: [Array, Object],
            default: () => {}
        },
        isSelected: {
            type: Object,
            default: () => {}
        }
    },
    data: () => ({
        errorCheckPrice: errorCheckPrice,
        optionsDelivery: [
          { text: 'Pick-Up (ขนส่งเข้ารับ)', value: 'pick_up' },
          { text: 'Drop-Off (นำส่งหน้าที่ทำการ)', value: 'drop_off' },
        ]
    }),
    methods:{
        deliveryServiceText(delivery_selected) {
            switch (delivery_selected) {
                case 'pick_up': 
                    return 'ขนส่งเข้ารับพัสดุ (Pick-Up)'
                case 'drop_off':
                    return 'นำส่งพัสดุหน้าสาขา (Drop-Off)'
                case 'pick_up_drop_off':
                    return 'ขนส่งเข้ารับพัสดุ/นำส่งพัสดุหน้าสาขา'
            }
        },
        displayLock(courier){
            // console.log('courier: ', courier)
            if(courier.sum_price_shop === 0 || courier.lockCourier === true){
                return true;
            }

            // let areaFreeze = courier.shipment.filter( item => {
            //     item.remark_area_freeze !== null
            // })

            // if( areaFreeze.length > 0){
            //     return true
            // }
        },
        selectCourier( keyId ){
            console.log('select courier key !! ', keyId, this.courierList)
            console.log('this courierList: ', this.courierList[keyId].delivery_selected)
            if (this.courierList[keyId].delivery_selected === 'pick_up') {
                this.isSelected.delivery_selected = 'pick_up'
                this.optionsDelivery = [
                    { text: 'Pick-Up (ขนส่งเข้ารับ)', value: 'pick_up'  },
                    { text: 'Drop-Off (นำส่งหน้าที่ทำการ)', value: 'drop_off', disabled: true }
                ]
            } else if (this.courierList[keyId].delivery_selected === 'drop_off') {
                this.isSelected.delivery_selected = 'drop_off'
                this.optionsDelivery = [
                    { text: 'Pick-Up (ขนส่งเข้ารับ)', value: 'pick_up', disabled: true },
                    { text: 'Drop-Off (นำส่งหน้าที่ทำการ)', value: 'drop_off' }
                ]
            } else if (this.courierList[keyId].delivery_selected === 'pick_up_drop_off') {
                this.isSelected.delivery_selected = 'pick_up'
                this.optionsDelivery = [
                    { text: 'Pick-Up (ขนส่งเข้ารับ)', value: 'pick_up'},
                    { text: 'Drop-Off (นำส่งหน้าที่ทำการ)', value: 'drop_off' }
                ]
            }
            console.log('this.isSelected: ', this.isSelected)
            this.isSelected.courierIndex = keyId;
            this.isSelected.list = this.courierList[keyId];
            this.isSelected.errorShow = false
        },
    }
}

</script>
<style lang="scss" scoped>
#btn-radio-delivery {
    width: 70%;
    cursor: pointer;
}
</style>